import { render, staticRenderFns } from "./DistrictAdd.vue?vue&type=template&id=377d437f&scoped=true&"
import script from "./DistrictAdd.vue?vue&type=script&lang=js&"
export * from "./DistrictAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d437f",
  null
  
)

export default component.exports